import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Apply from "@/pages/Apply";
import Donate from "@/pages/Donate";
import DonationSuccess from "@/pages/DonationSuccess";
import DonationCancel from "@/pages/DonationCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/donate/success" element={<DonationSuccess />} />
          <Route path="/donate/cancel" element={<DonationCancel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
